import axios from "axios";
import { useInfiniteQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { BASE_PATH } from "api/commonApi";
import { IHeadersProps, headersState } from "recoil/userInfoAtom";
import { langCodeState, searchState } from "recoil/commonUiAtom";
import { isProfilePageState } from "recoil/contentsAtom";
import { useParams } from "react-router-dom";

export interface IPostContent {
  admin_icon: string;
  admin_flag: number;
  comment_count: number;
  content: string;
  created_at: string;
  idx: number;
  images: [];
  like_count: number;
  user_nickname: string;
  title: string;
  user_id: string;
  user_like_status: number;
  user_Serial_from: number;
  user_Serial_to: number;
  user_nickname_from: string;
  user_nickname_to: string;
  profile_image_url_from: string;
  profile_key: string;
}

interface IProps {
  service_code: string | undefined;
  sectionTItle: string;
}

export const useInfiniteScrollQuery = (props: IProps) => {
  const searchVal = useRecoilValue(searchState);
  const langCode = useRecoilValue(langCodeState);
  const headers = useRecoilValue(headersState);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const { profilekey } = useParams();
  const type = isProfilePage ? "profile_board_list" : "page_board_list";

  const getPageBoard = async ({ pageParam = 1 }) => {
    const api = isProfilePage
      ? `${BASE_PATH}/api/vfunlounge/profile/post?user_profile_key=${profilekey}&page=${pageParam}`
      : `${BASE_PATH}/api/vfunlounge/posts/${props.service_code}/${props.sectionTItle}?lang=${langCode}&page=${pageParam}&search=${searchVal}`;

    const res = await axios.get(api, {
      headers: {
        ...headers
      }
    });

    return {
      result: res.data.result,
      boardpage: res.data.result === 1 ? res.data.data.data : "",
      currentpage: res.data.result === 1 ? res.data.data.current_page : 0,
      total: res.data.result === 1 ? res.data.data.total : 0,
      isLast:
        res.data.result === 1
          ? res.data.data.current_page === res.data.data.last_page
            ? true
            : false
          : false
    };
  };

  const dependData = isProfilePage ? profilekey : props.sectionTItle;

  const {
    data: getBoard,
    fetchNextPage: getNextPage,
    isSuccess: getBoardIsSuccess,
    hasNextPage: getNextPageIsPossible
  } = useInfiniteQuery([type, searchVal, langCode, dependData], getPageBoard, {
    getNextPageParam: (lastPage, pages) => {
      // lastPage와 pages는 콜백함수에서 리턴한 값을 의미한다!!
      // lastPage: 직전에 반환된 리턴값, pages: 여태 받아온 전체 페이지
      if (!lastPage.isLast) {
        return lastPage.currentpage + 1;
      }
      // 마지막 페이지면 undefined가 리턴되어서 hasNextPage는 false가 됨!
      return undefined;
    }
  });

  return { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible };
};

interface deleteProps {
  headers: IHeadersProps;
  api: string;
}

export const DeleteApi = async (props: deleteProps) => {
  const { headers, api } = props;

  const res = await axios.delete(api, {
    headers: { ...headers, "Content-Type": "multipart/form-data" }
  });

  return res;
};

export interface ILastComment {
  data: {
    board_idx: number;
    comment: string;
    comment_count: number;
    created_at: string;
    user_nickname: string;
    images: string | null;
    user_profile_key: string;
    profile_image_url_from: string;
    user_Serial: number;
    user_id: string;
    admin_flag: number;
    admin_icon: string;
  };
  result: number;
}

export const getLastComment = (headers: {}, idx: number, isProfilePage: boolean,) =>
  axios
    .get(
      `${BASE_PATH}/api/vfunlounge/${isProfilePage
        ? `profile/post/last_comment/${idx}`
        : `post/last_comment/${idx}`
      }`,
      {
        headers: headers
      }
    )
    .then((res) => res.data);

export interface ILikelounge {
  data: {
    is_new: boolean;
    library_url: string;
    lounge_url: string;
    thumbnail: string;
    title: string;
  }[];
  result: number;
}

export const getLikeList = (
  profilekey: string,
  landCode: string,
  type: string
) =>
  axios
    .get(
      `${BASE_PATH}/api/vfunlounge/profile/user_like_list/${profilekey}?lang=${landCode}&type=${type}`
    )
    .then((res) => res.data);
